<template>
  <div class="st bg-banner sec-attractions mb-0 sec-attractions-detail">
    <div class="ele ele-kv-cloud-detail d-none d-xl-block"> <img class="fw" src="@/assets/list-detail/el-banner-cloud.png" alt="" /> </div>
   
    <div class="att-unseen-bg position-relative"> 
        <div class="ele ele-kv-cloud-detail d-xl-none d-block"> <img class="fw" src="@/assets/list-detail/el-banner-cloud-m.png" alt="" /></div>
        <img class="d-lg-block d-none" :src="require(`@/assets/list-detail/${bannerArray[0].image_d}`)" alt="">
        <img class="d-lg-none " :src="require(`@/assets/list-detail/${bannerArray[0].image_m}`)" alt="">
    </div>

   
    <div class="att-unseen-cont">
        <div class="container ">
            <div class="position-relative">
                <div class="st attracbanner-title">
                    <div class="box-title">
                        <h1 class="text-light mb-0" ><span
                                class=""><b>{{ bannerArray[0].title }}</b></span></h1>
                        <h3 class="text-light font-second"><span class="">จังหวัด{{ bannerArray[0].adds }}</span></h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="fw unseen-cont-ps">
        <div class="container">
            <div class="box-content attrac-dtail-conts text-light">
                <div class="box-subtitle mb-3">
                    <span class="text-light"><a @click="toHome(bannerArray[0].region_en)" class="txt-sub-link" href="javascript:void(0)">{{bannerArray[0].region_th}}</a> / <span><b>{{bannerArray[0].title}}</b></span></span>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class=" bg-gd attractiondtl-detail-conts">
                <div class="row">
                    <div class="col-12 col-xl-12 order-xl-0 order-1">
                        <div class="attrac-banner-conts pt-0">
                            <a class="location-txt text-light pb-4 btn-icon  txt-w-og d-block" :href="bannerArray[0].gogole_link" target="_blank" rel="noopener noreferrer">   <span class="justify-content-start"><img src="@/assets/img/skin/icon-pin.svg" class="svg" alt=""><span>{{ bannerArray[0].adds_2 }}</span></span> </a>
                            <p class="text-white" v-html="bannerArray[0].desc"> </p>
                        </div>
                        <div class="location-tel d-block">
                            <div class="text-light fw btn-icon txt-location txt-w-og box-contact-location">
                                <span class="justify-content-start"><img src="@/assets/img/skin/icon-phone.svg" class="svg" alt=""><span v-html="bannerArray[0].link"></span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['bannerArray'],
    mounted(){
    },
    methods: {
        toHome(index) {
            this.home = true,
                this.$router.push({ path: '/', query: { data: index } });
        },
    },
}
</script>


<style scoped>

.att-unseen-bg { position: relative;}
.att-unseen-bg:before { content: ""; position: absolute; top: 0; left: 0; width: 100%; height: 50%;background: rgb(36,0,29);background: linear-gradient(180deg, rgba(36,0,29,1) 0%, rgba(0,0,0,0) 100%); opacity: 0.7;}


.sec-attractions-detail{position: relative;}
.ele-kv-cloud-detail{
    position: absolute;
    width: 100%;
    z-index: 1;
    bottom: -8vw;
    pointer-events: none;
    transform: none;
    top: auto;
    left: 0;
}
.att-unseen-bg{width: 100%;float: left;}
.att-unseen-bg img{width: 100%;float: left;}
.att-unseen-cont {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
}
.ele-kv-cloud-detail {
    position: absolute;
    width: 100%;
    z-index: 1;
    bottom: -30px;
    pointer-events: none;
}

.unseen-cont-ps{margin-top: -18vw;}


@media (max-width: 1599.98px) {
    .ele-kv-cloud-detail{ bottom: 2vw;}
}
@media (max-width: 1199.98px) {
    .ele-kv-cloud-detail{ bottom: -60px;}

    .sec-attractions-detail .box-title, .box-subtitle{margin: 0;top: 0;}
    /* .attrac-banner-conts{margin-top: 30px;} */
}
@media (max-width: 991.98px) {
.attractiondtl-detail-conts{margin-top: 10px;}
.unseen-cont-ps{margin-top:-150px;}
}
@media (max-width: 767.98px) {
.sec-attractions-detail .box-subtitle{top:0;}
.attractiondtl-detail-conts{top:0;margin-top: 0px;}

.unseen-cont-ps{margin-top: -70px;}
}
</style>